<section class="content">
  <div class="container-fluid">
    <ng-content></ng-content>
  </div>
</section>
